import type { SettingValue, SettingsKey, SettingsScope } from './settings-slice';
import { type Settings } from './types';

export const LATEST_VERSION = 1;

export type SettingsDocument = {
  version: typeof LATEST_VERSION;
  id: string;
  createdAt: string;
  updatedAt: string;
} & Settings;

export type GetSettingsApiArg = {
  projectId: string;
};

export type CreateSettingsApiArg = {
  projectId: string;
  settings: Omit<SettingsDocument, 'id' | 'createdAt' | 'updatedAt' | 'version'>;
};

export type UpdateSettingsApiArg<
  Scope extends SettingsScope = SettingsScope,
  Key extends SettingsKey<Scope> = SettingsKey<Scope>,
> = {
  projectId: string;
  id: SettingsDocument['id'];
  scope: Scope;
  key: Key;
  value: SettingValue<Scope, Key>;
};
